import { useEffect } from 'react';
import { useRouter } from 'next/router';
import mixpanel from 'mixpanel-browser';

import { MixPanel } from '~/shared/lib/mixpanel';

import { LcmUserSession } from '../auth/types/next-auth';

export function useInitMixPanel(session: LcmUserSession) {
  const router = useRouter();
  useEffect(() => {
    MixPanel.initMixpanel();

    try {
      if (session.user && process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
        const { user } = session;
        mixpanel.identify(user.employeeId);
        mixpanel.people.set({
          globalId: user.globalId,
          band: user.band,
          zone: user.zone,
          roles: user.roles,
          country: user.country,
          isManager: user.isManager,
          $name: user.name,
        });
      }
    } catch (err) {
      console.error('Failed to init mixpanel');
    }
  }, [router.events, session]);
}
